import { useEffect } from 'react';
import { useNavigate, RouteObject } from 'react-router-dom';
import { GO_TO_ROUTE_ACTION } from '@restore/tools';
import { subscribeToActions } from '@restore/store';

export function SagaRouter() {
  const navigate = useNavigate();

  useEffect(() => {
    return subscribeToActions(GO_TO_ROUTE_ACTION, action => {
      navigate(action.payload);
    });
  }, [navigate]);
  return null;
}

export function wrapWithSagaRouter(routes: RouteObject[]) {
  return routes.map(r => {
    return {
      ...r,
      element: (
        <>
          <SagaRouter />
          {r.element}
        </>
      ),
    };
  });
}
